export default function joinTexts(values: unknown[], delimiter: string) {
  const texts = values.filter(
    (text) => text && typeof text === 'string' && text !== '',
  )

  return texts?.length ? texts.join(delimiter) : null
}
